import { zillowURL } from '@zillow/url';

// This function provides some useful logic which points links at the develop environment when
// developing locally, but it also points links at the develop environment when they are rendered
// on the server-side. Because we don't want production links (for example) pointing at develop
// just because they were rendered server-side, this function should ONLY be used for links rendered
// client-side
export const getClientSideZillowUrl = zillowURL;

export const getOwnerDashboardUrl = (zpid: number, showSuccessToast: boolean): string =>
    getClientSideZillowUrl(
        `/myzillow/yourhome/${zpid}${showSuccessToast ? '?isSuccessfullyClaimed=true' : ''}`
    ) as string;

export const convertToLowerCaseParams = (params: URLSearchParams) => {
    const newParams = new URLSearchParams();
    params.forEach((value, key) => {
        newParams.append(key.toLowerCase(), value);
    });
    return newParams;
};
